import { useContext } from "react"
import { GlobalContext } from "../../store/GlobalProvider"
import {
  SET_MFA_DIALOG,
  SET_CONSENT_ACCEPTED_OPTIONS,
  SET_TENANT_SETTINGS,
  INITIALIZE_SDK,
  SET_CURRENT_USER,
  SET_AUTHENTICATED,
  SET_LOADING,
  SET_SDK_ERROR,
  TOGGLE_BACKDROP,
  SET_TENANT_ID,
  SET_CONFIG,
  SET_ERROR,
  SET_CONSENT_DECISIONS,
  SET_VERIFF_SESSION_DATA,
  SET_CURRENT_USER_MARKET,
} from "../../store/actionTypes"
import { getErrorMessage } from "../common"
const useGlobalContext = () => {
  const [state, dispatch] = useContext(GlobalContext)

  const setMfaDialog = (data) => {
    dispatch({ type: SET_MFA_DIALOG, payload: data })
  }

  const setConsentAcceptedOptions = (data) => {
    dispatch({ type: SET_CONSENT_ACCEPTED_OPTIONS, payload: data })
  }

  const setTenantSettings = (data) => {
    dispatch({ type: SET_TENANT_SETTINGS, payload: data })
  }

  const setSdkInitialized = (data) => {
    dispatch({ type: INITIALIZE_SDK, payload: data })
  }

  const setCurrentUser = (data) => {
    dispatch({ type: SET_CURRENT_USER, payload: data })
  }

  const setAuthenticated = (data) => {
    dispatch({ type: SET_AUTHENTICATED, payload: data })
  }

  const setLoading = (data) => {
    dispatch({ type: SET_LOADING, payload: data })
  }

  const setSDKError = (data) => {
    dispatch({ type: SET_SDK_ERROR, payload: data })
  }

  const toggleBackdrop = (data) => {
    dispatch({ type: TOGGLE_BACKDROP, payload: data })
  }

  const setTenantId = (data) => {
    dispatch({ type: SET_TENANT_ID, payload: data })
  }

  const setConfig = (data) => {
    dispatch({ type: SET_CONFIG, payload: data })
  }

  const setError = (e) => {
    if (e && e.response) {
      let message = getErrorMessage(e)
      dispatch({
        type: SET_ERROR,
        payload: { hasError: true, errorMessage: message },
      })
    } else if (e && e.message) {
      dispatch({
        type: SET_ERROR,
        payload: { hasError: true, errorMessage: e.message },
      })
    } else {
      dispatch({
        type: SET_ERROR,
        payload: { hasError: false, errorMessage: "" },
      })
    }
  }

  const setConsentDecisions = (data) => {
    dispatch({ type: SET_CONSENT_DECISIONS, payload: data })
  }

  const setVeriffSessionData = (data) => {
    dispatch({ type: SET_VERIFF_SESSION_DATA, payload: data })
  }

  const setCurrentUserMarket = (data) => {
    dispatch({ type: SET_CURRENT_USER_MARKET, payload: data })
  }

  return {
    state,
    setMfaDialog,
    setConsentAcceptedOptions,
    setTenantSettings,
    setSdkInitialized,
    setCurrentUser,
    setAuthenticated,
    setLoading,
    setSDKError,
    toggleBackdrop,
    setTenantId,
    setConfig,
    setError,
    setConsentDecisions,
    setVeriffSessionData,
    setCurrentUserMarket,
  }
}

export default useGlobalContext
